import FletBox from "./FletBox";
export default FletBox;
